import styled from "styled-components";

import type { LeaderboardEntry } from "../api/types";

// A single leaderboard row: rank · avatar · name · score. Highlights the viewer
// ("You" marker, PRD requires). No rank deltas (out of scope v1).
const Row = styled.div<{ $you?: boolean }>`
  display: grid;
  grid-template-columns: 26px 30px 1fr auto;
  gap: ${({ theme }) => theme.space(3)};
  align-items: center;
  padding: ${({ theme }) => `${theme.space(3)} ${theme.space(3)}`};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ $you, theme }) => ($you ? theme.color.accentSoft : "transparent")};
  border: 1px solid ${({ $you }) => ($you ? "rgba(0, 152, 234, 0.3)" : "transparent")};
`;

const Rank = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.textDim};
  text-align: center;
`;

const Avatar = styled.span<{ $you?: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.font.mono};
  font-weight: 600;
  font-size: 12px;
  background: ${({ theme, $you }) => ($you ? theme.color.accent : theme.color.surfaceRaised)};
  color: ${({ theme, $you }) => ($you ? "#fff" : theme.color.textDim)};
`;

const Name = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const You = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 11px;
  color: ${({ theme }) => theme.color.accent};
  margin-left: 6px;
`;

const Score = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.text};
`;

function initialOf(name: string | undefined): string {
  const cleaned = (name ?? "").replace(/^@/, "").trim();
  return (cleaned[0] ?? "?").toUpperCase();
}

export function RankRow({ entry, you }: { entry: LeaderboardEntry; you?: boolean }) {
  return (
    <Row $you={you}>
      <Rank>{String(entry.rank).padStart(2, "0")}</Rank>
      <Avatar $you={you}>{you ? "Y" : initialOf(entry.displayName)}</Avatar>
      <Name>
        {entry.displayName}
        {you && <You>you</You>}
      </Name>
      <Score>{entry.score.toLocaleString()}</Score>
    </Row>
  );
}
